export default __webpack_public_path__ + "static/media/icon-x.43357eeb.svg";